import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useMediaQuery } from "@mui/material";
import { ResponsiveDialog } from "../../Components/Dialog/ResponsiveDialog.js";
const ConfirmActionDialog = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmDisabled = false,
  onConfirm,
  onCancel,
  backgroundColor = "#ffffff",
  primaryColor = "#0d2340",
  primaryForegroundColor = "#ffffff",
  fontFamily
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const cancelButton = /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      onClick: onCancel,
      style: {
        padding: "0 24px",
        border: `1px solid ${primaryColor}`,
        borderRadius: 100,
        backgroundColor,
        color: primaryColor,
        cursor: "pointer",
        fontSize: isMobile ? 15 : 14,
        fontWeight: 600,
        lineHeight: "22px",
        height: isMobile ? 48 : 40,
        width: isMobile ? "100%" : void 0,
        boxSizing: "border-box",
        fontFamily: "inherit"
      },
      children: cancelText
    }
  );
  const confirmButton = /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      onClick: onConfirm,
      disabled: confirmDisabled,
      style: {
        padding: "0 24px",
        border: `1px solid ${primaryColor}`,
        borderRadius: 100,
        backgroundColor: primaryColor,
        color: primaryForegroundColor,
        cursor: confirmDisabled ? "not-allowed" : "pointer",
        fontSize: isMobile ? 15 : 14,
        fontWeight: 600,
        lineHeight: "22px",
        height: isMobile ? 48 : 40,
        width: isMobile ? "100%" : void 0,
        boxSizing: "border-box",
        opacity: confirmDisabled ? 0.7 : 1,
        fontFamily: "inherit"
      },
      children: confirmText
    }
  );
  return /* @__PURE__ */ jsx(
    ResponsiveDialog,
    {
      open,
      onClose: onCancel,
      disableScrollLock: true,
      sx: (theme) => ({
        zIndex: 1e4,
        // Hide ResponsiveDialog's desktop close (✕) icon — the Chat History /
        // desktop spec for this dialog uses backdrop-click + Cancel only.
        "& .bc_dialog_close_button": { display: "none" },
        "& div.MuiDialog-paper": {
          margin: "0 20px",
          width: "100%",
          maxWidth: 584,
          height: 172,
          backgroundColor,
          paddingTop: 0,
          borderRadius: "10px",
          [theme.breakpoints.down("md")]: {
            maxWidth: "100%",
            width: "100%",
            height: "auto",
            margin: 0,
            paddingTop: "24px",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
          }
        }
      }),
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            padding: isMobile ? "16px 24px 32px" : "24px 15px 16px 24px",
            backgroundColor,
            ...fontFamily ? { fontFamily } : {}
          },
          children: [
            /* @__PURE__ */ jsx(
              "p",
              {
                style: {
                  margin: 0,
                  color: primaryColor,
                  fontSize: isMobile ? 22 : 16,
                  fontWeight: isMobile ? 700 : 500,
                  lineHeight: isMobile ? "30px" : "24px",
                  textAlign: isMobile ? "center" : "left"
                },
                children: title
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  marginTop: 8,
                  color: primaryColor,
                  fontSize: 16,
                  fontWeight: isMobile ? 400 : 500,
                  lineHeight: "24px",
                  textAlign: isMobile ? "center" : "left"
                },
                children: message
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                style: isMobile ? {
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  marginTop: 32
                } : {
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 8,
                  marginTop: 36
                },
                children: isMobile ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  confirmButton,
                  cancelButton
                ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
                  cancelButton,
                  confirmButton
                ] })
              }
            )
          ]
        }
      )
    }
  );
};
export {
  ConfirmActionDialog
};
//# sourceMappingURL=ConfirmActionDialog.js.map
